module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Bold.445f96a3.woff";